// Illustrative-only label — dashboards depict sample data, not real client results.
// Shared pill component used across all dashboard visuals for consistency.
export default function IllustrativePill({ position = "top-3 right-3", z = "z-20" }) {
  return (
    <div
      className={`absolute ${position} ${z} inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[9.5px] tracking-[0.22em] uppercase font-medium text-platinum/70 pointer-events-none`}
      style={{
        background: "rgba(10,15,26,0.72)",
        border: "1px solid rgba(96,165,250,0.28)",
        backdropFilter: "blur(8px)",
      }}
      data-testid="illustrative-label"
    >
      <span
        className="w-1 h-1 rounded-full bg-sapphire-glow"
        style={{ boxShadow: "0 0 6px rgba(96,165,250,0.85)" }}
      />
      Illustrative interface
    </div>
  );
}
